<ng-container *transloco="let convert;">
  @if (tenantName$ | async; as tenantName) {
    <section class="alerts-others">
      @if (users$ | async; as users) {
        <header class="mb-3">
          <h2 data-test-id="alerts-others-header-page-title" tabindex="-1" class="focus-outline-none mb-0" #pageHeading aria-describedby="pageDescription">
            {{convert('profileManagement.alertsOthers.pageHeader')}}
          </h2>
          <p data-test-id="alerts-others-header-page-description" class="mb-1" id="pageDescription">{{convert('profileManagement.alertsOthers.pageDescription')}}</p>
          @if (showError) {
            <error-message data-test-id="alerts-others-header-error-message"></error-message>
          }
          @if (showSuccess) {
            <success-message data-test-id="alerts-others-header-success-message" [message]="message"></success-message>
          }
          @if (removedUser) {
            <aside class="media form-message form-message__undo">
              <div class="me-2 form-message__icon">
                <i aria-hidden="true" class="allycon-success-fill text-success"></i>
              </div>
              <div class="media-body">
                <strong class="align-middle"><span [innerHTML]="convert('profileManagement.alertsOthers.removeRecipientSuccessMessage', {removedUser : removedUser.name})"></span></strong>
                <button
                  data-test-id="alerts-others-header-undo-button"
                  data-track-elem="button"
                  data-track-name="Undo"
                  class="btn btn-link p-0 ms-1 ms-lg-2 d-inline-block"
                  (click)="undoRemove()"
                  >
                  {{convert('profileManagement.alertsOthers.buttonUndo')}}
                </button>
              </div>
            </aside>
          }
        </header>
        <app-legacy-table
          data-test-id="alerts-others-users-table"
          [columns]="columns"
          [data]="users"
          [tenantName]="tenantName"
          [cardConfig]="cardConfig"
          [caption]="convert('profileManagement.alertsOthers.captionOtherRecipients')"
          >
          @for (user of users; track userById($index, user)) {
            <table-row-group>
              <table-row [columns]="columns" [row]="user">
                <table-cell *appTableCell="let row; column: 'options'">
                  <div class="alerts-others__user-options">
                    <button
                      [attr.data-test-id]="'alerts-others-users-manage-button-' + $index"
                      data-track-elem="button"
                      data-track-name="Manage"
                      class="btn btn-link py-0 ps-0 pe-lg-2"
                      (click)="manageUser(user, drawer)"
                      [attr.aria-label]="convert('profileManagement.alertsOthers.ariaLabelManage') + row.name"
                      [attr.id]="'manage_' + row.uuid + '_button'"
                      >
                      {{convert('profileManagement.alertsOthers.buttonManage')}}
                    </button>
                    <button
                      [attr.data-test-id]="'alerts-others-users-remove-button-' + $index"
                      data-track-elem="button"
                      data-track-name="Remove"
                      class="btn btn-link py-0"
                      (click)="this.removeUser(user)"
                      [attr.aria-label]="convert('profileManagement.alertsOthers.ariaLabelRemove') + row.name"
                      >
                      {{convert('profileManagement.alertsOthers.bttonRemove')}}
                    </button>
                  </div>
                </table-cell>
              </table-row>
              <table-row
                [row]="user"
                [expandable]="true"
                #drawer="table-row"
                data-track-elem="accordion"
                data-track-trigger="statechange"
                >
                <table-cell *appTableCell="let row; colSpan: columns.length; classes: 'p-0'">
                  @if (drawer.isOpen && editForm) {
                    <app-alerts-others-add-edit-form
                      [attr.data-test-id]="'alerts-others-users-edit-form-' + $index"
                      [tenantName]="tenantName"
                      [showCancelWarning]="showEditFormCancelWarning"
                      [recipientForm]="editForm"
                      (cancelEdit)="cancelEditing()"
                      (continueEdit)="continueEditing()"
                      (confirmCancel)="confirmCancelEdit()"
                      (save)="saveEditForm($event)"
                      [recipient]="row"
                      [buyAlerts$]="buyAlerts$"
                      [sellAlerts$]="sellAlerts$"
                      [visibilityFlags]="visibilityFlags"
                      (closeDrawer)="editDrawer.close()"
                      >
                      <span form-title>{{convert('profileManagement.alertsOthers.formTitle')}}</span>
                      <span confirm-button>{{convert('profileManagement.alertsOthers.buttonConfirm')}}</span>
                      <span cancel-button>{{convert('profileManagement.alertsOthers.buttonGoBack')}}</span>
                    </app-alerts-others-add-edit-form>
                  }
                </table-cell>
              </table-row>
            </table-row-group>
          }
          <table-footer>
            <table-row>
              <table-cell *appTableCell="let row; colSpan: columns.length">
                <div class="alerts-others__footer">
                  <button
                    data-test-id="alerts-others-footer-add-user-button"
                    data-track-elem="button"
                    data-track-name="Add"
                    class="btn btn-link py-0 add-user"
                    (click)="addUser()"
                    [attr.aria-label]="convert('profileManagement.alertsOthers.ariaLabelAddRecipient')"
                    >
                    <em class="allycon-glyph-plus me-2 align-text-bottom"></em> {{convert('profileManagement.alertsOthers.buttonAdd')}}
                  </button>
                </div>
              </table-cell>
            </table-row>
            <table-row [expandable]="true" #footerDrawer="table-row">
              <table-cell *appTableCell="let row; colSpan: columns.length; classes: 'p-0'">
                @if (footerDrawer.isOpen) {
                  <app-alerts-others-add-edit-form
                    data-test-id="alerts-others-footer-add-form"
                    [tenantName]="tenantName"
                    [recipientForm]="addForm"
                    [showCancelWarning]="showAddFormCancelWarning"
                    (cancelEdit)="confirmCancelAdd()"
                    (continueEdit)="continueAdding()"
                    (confirmCancel)="confirmCancelAdd()"
                    (save)="saveAddForm($event)"
                    [buyAlerts$]="buyAlerts$"
                    [sellAlerts$]="sellAlerts$"
                    [visibilityFlags]="visibilityFlags"
                    (closeDrawer)="footerDrawer.close()"
                    >
                    <span form-title>{{convert('profileManagement.alertsOthers.titleAddRecipient')}}</span>
                    <span confirm-button>{{convert('common.btnClose')}}</span>
                    <span cancel-button>{{convert('common.btnCancel')}}</span>
                  </app-alerts-others-add-edit-form>
                }
              </table-cell>
            </table-row>
          </table-footer>
        </app-legacy-table>
      }
    </section>
  }
</ng-container>
